// extracted by mini-css-extract-plugin
export default {"no-more-tip":"VmWTj_no-more-tip","txt":"ESDCa_txt"};